import { useCallback, useState } from 'react';
import { redirectToPortalLogin, signOutFromPortal } from '@/lib/portalLogout';

export function usePortalLogout() {
  const [logoutConfirm, setLogoutConfirm] = useState(false);
  const [isSigningOut, setIsSigningOut] = useState(false);
  const [logoutError, setLogoutError] = useState<string | null>(null);

  const openLogoutConfirm = useCallback(() => {
    if (isSigningOut) return;
    setLogoutError(null);
    setLogoutConfirm(true);
  }, [isSigningOut]);

  const closeLogoutConfirm = useCallback(() => {
    if (isSigningOut) return;
    setLogoutConfirm(false);
    setLogoutError(null);
  }, [isSigningOut]);

  const performLogout = useCallback(async () => {
    if (isSigningOut) return;

    setIsSigningOut(true);
    setLogoutError(null);
    setLogoutConfirm(false);

    const result = await signOutFromPortal();
    if (!result.ok) {
      setLogoutError(result.error);
      setIsSigningOut(false);
      setLogoutConfirm(true);
      return;
    }

    redirectToPortalLogin();
  }, [isSigningOut]);

  return {
    logoutConfirm,
    openLogoutConfirm,
    closeLogoutConfirm,
    performLogout,
    isSigningOut,
    logoutError,
  };
}
